import { colors } from '@kmns-internal/furikake/tokens'
import { Stack, Typography } from '@mui/material'
import { SubmissionRateProgress } from 'src/features/monitoringDashboardAlpha/components/SubmissionRateProgress/SubmissionRateProgress'
import { computeSubmissionRate } from 'src/features/monitoringDashboardAlpha/selector/computeSubmissionRate'
import { DashboardSummary } from 'src/features/monitoringDashboardAlpha/types'

type Props = {
  /** 全現場合計（現場で絞り込んでいる場合はその対象分）のサマリー */
  summary: DashboardSummary
}

/**
 * サマリーカードの上に表示する、全体の実施率（横棒グラフ + パーセント）
 *
 * 「全体でどれだけ実施できているか」をひと目で把握できるようにするためのもの。
 * 実施率の定義は現場ごとの実施率バー（computeSubmissionRate）と揃えており、
 * 母数から「開始前」を除いている旨をラベルに明記する。
 */
export const OverallSubmissionRate = ({ summary }: Props) => {
  const rate = computeSubmissionRate(summary)
  const isComplete = rate >= 100

  return (
    <Stack spacing={0.5}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
      >
        <Typography variant="body2" sx={{ color: colors.text.secondary }}>
          実施率（開始前を除く）
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            // 100% のときだけ primary、それ以外は通常テキスト色
            color: isComplete ? colors.primary.main : colors.text.primary,
          }}
        >
          {rate}%
        </Typography>
      </Stack>
      <SubmissionRateProgress rate={rate} />
    </Stack>
  )
}
